import ImageWithBasePath from "@/components/image-with-base-path"


const ItSection = () => {
  return (
    <>
  {/* Start How It Section */}
  <section className="section how-section-fifteen">
    <div className="container">
      {/* start row */}
      <div className="row align-items-center">
        <div className="col-xl-6">
          <div
            className="section-header section-header-fifteen wow fadeInUp"
            data-wow-duration="2s"
          >
            <div className="section-sub-title">How It Works</div>
            <h2 className="section-title">
              How Booking Process <br /> <span>Works For You</span>
            </h2>
          </div>
          {/* Item 1 */}
          <div className="how-item-fifteen wow fadeInUp" data-wow-duration="2s">
            <div className="how-inner-title">
              <span className="how-subtitle">STEP 1</span>
              <h3 className="how-title">Choose Your Specialist</h3>
              <p className="description">
                Browse trusted mental health professionals and select the right
                therapist based on your needs and preferences.
              </p>
            </div>
            <div className="how-item-img">
              <ImageWithBasePath
                src="assets/img/icons/how-icon-1.svg"
                alt="icon"
                className="img-fluid icon-1"
              />
              <ImageWithBasePath
                src="assets/img/icons/how-icon-4.svg"
                alt="icon"
                className="img-fluid icon-2"
              />
            </div>
          </div>
          {/* Item 2 */}
          <div className="how-item-fifteen wow fadeInUp" data-wow-duration="2s">
            <div className="how-inner-title">
              <span className="how-subtitle">STEP 2</span>
              <h3 className="how-title">Book Your Session</h3>
              <p className="description">
                Pick a convenient date and time, and schedule your of you and
                appointment quickly and securely online.
              </p>
            </div>
            <div className="how-item-img">
              <ImageWithBasePath
                src="assets/img/icons/how-icon-2.svg"
                alt="icon"
                className="img-fluid icon-1"
              />
              <ImageWithBasePath
                src="assets/img/icons/how-icon-4.svg"
                alt="icon"
                className="img-fluid icon-2"
              />
            </div>
          </div>
          {/* Item 3 */}
          <div className="how-item-fifteen wow fadeInUp" data-wow-duration="2s">
            <div className="how-inner-title">
              <span className="how-subtitle">STEP 3</span>
              <h3 className="how-title">Start Your Healing Journey</h3>
              <p className="description">
                Connect with your therapist, share your concerns, and begin your
                path toward better mental well-being.
              </p>
            </div>
            <div className="how-item-img">
              <ImageWithBasePath
                src="assets/img/icons/how-icon-3.svg"
                alt="icon"
                className="img-fluid icon-1"
              />
              <ImageWithBasePath
                src="assets/img/icons/how-icon-4.svg"
                alt="icon"
                className="img-fluid icon-2"
              />
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="how-img-fifteen ps-5 d-none d-xl-block">
            <ImageWithBasePath
              src="assets/img/features/choose-img-2.png"
              alt="choose"
              className="img-fluid img-1"
            />
          </div>
        </div>
      </div>
      {/* end row */}
    </div>
  </section>
  {/* End How It Section */}
</>

  )
}

export default ItSection